/* Skapad av Claude Code — Godispaket-picker v3 · 2026-08-08.
   MEKANIKEN ÄR IDENTISK MED v2.1 (blanda storlekar): interceptar köpknappen
   när paketet är >1 enhet och skickar alla rader via /cart/add.js med
   line item-property _godispaket (Paket-motorn i svd-functions rabatterar).
   Nytt i v3 (endast presentation): "Du sparar X kr (Y %)"-raden ovanför
   köpknappen ([data-gp-save]) och pop-animationen (.is-pop) på trappsteget
   när en ny rabattnivå nås. */
(function () {
  'use strict';

  var PROPERTY_KEY = '_godispaket';

  var fmtCurrency = null; // sätts per picker när marknadens valuta ≠ SEK (Finland m.fl.)
  function fmtMoneyKr(cents) {
    // Shopify-priser är i ören. SEK: avrundat till hela kronor (rent). Annan valuta: Intl-format.
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    if (fmtCurrency) return fmtCurrency.format(cents / 100);
    return Math.round(cents / 100).toString() + ' kr';
  }

  // ============== Cart drawer-appen UpCart (samma mönster som svd-addons) ==============
  function hasUpCart() {
    return !!(window.upcart || document.querySelector('[id*="upcart" i], [class*="upcart" i]'));
  }
  function tryOpenUpCart() {
    try {
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
    } catch (e) { /* UpCart auto-öppnar normalt själv */ }
  }

  // ============== Temats cart drawer (Vision 2024) ==============
  var DRAWER_SECTIONS = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];
  function sectionInnerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }
  function renderDrawerSections(response) {
    if (!response || !response.sections) return;
    DRAWER_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = response.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = sectionInnerHTML(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    if (typeof window.CartDrawer !== 'undefined') {
      new window.CartDrawer();
    }
  }
  function openThemeCartDrawer(response) {
    var drawerEl = document.getElementById('Cart-Drawer');
    if (!drawerEl) return false;
    renderDrawerSections(response);
    document.body.classList.add('open-cc');
    drawerEl.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    return true;
  }

  // ============== Picker Controller ==============
  function initPicker(root) {
    if (root.getAttribute('data-gp-init') === '1') return;
    root.setAttribute('data-gp-init', '1');
    var gpCurrency = root.getAttribute('data-currency') || 'SEK';
    if (gpCurrency !== 'SEK' && window.Intl && Intl.NumberFormat) {
      try { fmtCurrency = new Intl.NumberFormat(root.getAttribute('data-locale') || 'sv', { style: 'currency', currency: gpCurrency }); } catch (e) { fmtCurrency = null; }
    }

    var mainRow = root.querySelector('[data-gp-main]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-gp-row]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-gp-tiers] .svd-gp__tier'));
    var moreBtn = root.querySelector('[data-gp-more]');
    var moreRows = root.querySelector('[data-gp-more-rows]');
    // v4 (mallstyrd, 2026-09-23) — två additiva krokar, v3-markup har ingen:
    // data-gp-stamp = stämpelns värde (produktmallens namn, paket-motorn
    // matchar det), data-gp-plain = enkelt köpläge utan stämpel. v4 kan sakna
    // tilläggsrader (tom lista, eller enkelt läge) och ska ändå starta.
    var gpStamp = root.getAttribute('data-gp-stamp');
    var gpPlain = root.hasAttribute('data-gp-plain');
    if (!mainRow || (rows.length === 0 && !gpStamp && !gpPlain)) return;

    var mainIsMulti = mainRow.hasAttribute('data-gp-multi');
    var moreCount = moreRows ? moreRows.querySelectorAll('[data-gp-row]').length : 0;

    // ---- Enkel rad (en variant): antal i yttre steppern, som v1 ----
    function rowQty(row) {
      var el = row.querySelector('[data-gp-qty]');
      return el ? parseInt(el.textContent, 10) || 1 : 1;
    }
    function setRowQty(row, qty) {
      var el = row.querySelector('[data-gp-qty]');
      if (el) el.textContent = String(qty);
    }

    // ---- Multi-rad (flera varianter): antal per variant i panelen ----
    function isMulti(container) {
      return container.hasAttribute('data-gp-multi');
    }
    function vopts(container) {
      return Array.prototype.slice.call(container.querySelectorAll('[data-gp-vopt]'));
    }
    function vqty(opt) {
      return parseInt(opt.querySelector('[data-gp-vqty]').textContent, 10) || 0;
    }
    function setVqty(opt, qty) {
      opt.querySelector('[data-gp-vqty]').textContent = String(qty);
      opt.classList.toggle('is-selected', qty > 0);
    }
    function optPrice(opt) {
      return parseInt(opt.getAttribute('data-price'), 10) || 0;
    }

    // ---- Gemensamt: enheter & pris per rad oavsett typ ----
    function containerUnits(container) {
      if (!isMulti(container)) return rowQty(container);
      return vopts(container).reduce(function (sum, o) { return sum + vqty(o); }, 0);
    }
    function containerCents(container) {
      if (!isMulti(container)) {
        return (parseInt(container.getAttribute('data-price'), 10) || 0) * rowQty(container);
      }
      return vopts(container).reduce(function (sum, o) { return sum + vqty(o) * optPrice(o); }, 0);
    }
    function checkedRows() {
      return rows.filter(function (row) { return row.classList.contains('is-checked'); });
    }
    function totalBags() {
      return checkedRows().reduce(function (sum, row) { return sum + containerUnits(row); }, containerUnits(mainRow));
    }

    // Huvudradens startläge (2 enheter i markupen — kunden ser rabatten direkt)
    var mainDefaultQty = containerUnits(mainRow) || 1;

    // Kompakt summering i radhuvudet ("1× S · 1× L") + radens sammanlagda pris
    function renderMix(container) {
      if (!isMulti(container)) return;
      var mixEl = container.querySelector('[data-gp-mix]');
      var isMain = container.hasAttribute('data-gp-main');
      var priceEl = container.querySelector(isMain ? '[data-gp-main-price]' : '[data-gp-row-price]');
      var parts = [];
      var cents = 0;
      vopts(container).forEach(function (o) {
        var q = vqty(o);
        if (q < 1) return;
        parts.push(q + '× ' + (o.getAttribute('data-vtitle') || ''));
        cents += q * optPrice(o);
      });
      if (mixEl) {
        mixEl.textContent = parts.join(' · ');
        mixEl.classList.toggle('is-on', parts.length > 0);
      }
      if (priceEl) {
        if (cents === 0) cents = optPrice(vopts(container)[0]);
        priceEl.textContent = (isMain ? '' : '+ ') + fmtMoneyKr(cents);
      }
    }

    var prevActiveMin = -1; // -1 = första renderingen (ingen pop vid sidladdning)
    function renderTiers() {
      var bags = totalBags();
      var activeMin = 0;
      var activePct = 0;
      tiers.forEach(function (tier) {
        var min = parseInt(tier.getAttribute('data-min'), 10) || 0;
        var reached = bags >= min;
        tier.classList.toggle('is-reached', reached);
        if (reached && min > activeMin) {
          activeMin = min;
          activePct = parseInt(tier.getAttribute('data-pct'), 10) || 0;
        }
      });
      tiers.forEach(function (tier) {
        var min = parseInt(tier.getAttribute('data-min'), 10) || 0;
        var isActive = activeMin > 0 && min === activeMin;
        tier.classList.toggle('is-active', isActive);
        // v3: pop på steget när en NY nivå nås (inte vid init eller nedsteg)
        if (isActive && prevActiveMin >= 0 && activeMin > prevActiveMin) {
          tier.classList.remove('is-pop');
          void tier.offsetWidth;
          tier.classList.add('is-pop');
        }
      });
      prevActiveMin = activeMin;
      renderAtcPrice(activePct);
    }

    // Paketpris på köpknappen — rabatterat + överstruket ordinarie (som Magbalans-pickern)
    var atcNow = root.querySelector('[data-gp-atc-now]');
    var atcWas = root.querySelector('[data-gp-atc-was]');
    var atcPrices = root.querySelector('[data-gp-atc-prices]');
    var saveEl = root.querySelector('[data-gp-save]');
    function renderSave(total, discounted, pct) {
      if (!saveEl) return;
      if (pct > 0 && total > discounted) {
        saveEl.textContent = (root.getAttribute('data-t-save') || 'Du sparar') + ' ' + fmtMoneyKr(total - discounted) + ' (' + pct + ' %)';
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }
    function renderAtcPrice(pct) {
      if (!atcNow || !atcPrices) return;
      var total = checkedRows().reduce(function (sum, row) { return sum + containerCents(row); }, containerCents(mainRow));
      if (!total) { atcPrices.hidden = true; renderSave(0, 0, 0); return; }
      var discounted = Math.round(total * (100 - pct) / 100);
      atcNow.textContent = fmtMoneyKr(discounted);
      if (atcWas) {
        if (pct > 0) {
          atcWas.textContent = fmtMoneyKr(total);
          atcWas.hidden = false;
        } else {
          atcWas.hidden = true;
        }
      }
      atcPrices.hidden = false;
      renderSave(total, discounted, pct);
    }

    // Huvudproduktens alla variant-id:n — används av både variantsynken och
    // submit-intercepten längre ner.
    var ownVariantIds = (root.getAttribute('data-product-variants') || '')
      .split(',')
      .filter(Boolean);

    // ============== Variantsynk mot sidan (endast huvudprodukten) ==============
    // Senast uppstegade storleken blir sidans valda variant (pris/bild uppe
    // följer den). data-main-variant håller "senast aktiva" varianten.
    function syncPageVariant(opt) {
      var vs = document.querySelector('variant-selects');
      if (!vs) return;
      var opts;
      try { opts = JSON.parse(opt.getAttribute('data-opts') || '[]'); } catch (e) { return; }
      var fieldsets = Array.prototype.slice.call(vs.querySelectorAll('fieldset'));
      fieldsets.forEach(function (fieldset, i) {
        if (i >= opts.length) return;
        var select = fieldset.querySelector('select');
        if (select) {
          select.value = opts[i];
          return;
        }
        Array.prototype.slice.call(fieldset.querySelectorAll('input')).forEach(function (input) {
          input.checked = (input.value === opts[i]);
        });
      });
      // Triggar temats onVariantChange → uppdaterar form-id, pris, media och
      // skickar product:variant-change (som vår lyssnare nedan tar emot — idempotent).
      vs.dispatchEvent(new Event('change'));
    }

    // Sidans variantväljare ändras → spegla i pickern. Är paketet oblandat
    // (en enda variant vald) flyttas antalet till den nya varianten; är det
    // blandat äger pickern kvantiteterna och bara "senast aktiva" uppdateras.
    document.addEventListener('product:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.id) return;
      if (ownVariantIds.indexOf(String(v.id)) === -1) return;
      root.setAttribute('data-main-variant', String(v.id));
      if (!mainIsMulti) {
        if (typeof v.price === 'number' && !isNaN(v.price)) {
          mainRow.setAttribute('data-price', String(v.price));
          var priceEl = mainRow.querySelector('[data-gp-main-price]');
          if (priceEl) priceEl.textContent = fmtMoneyKr(v.price);
        }
        renderTiers();
        return;
      }
      var target = mainRow.querySelector('[data-gp-vopt][data-variant-id="' + v.id + '"]');
      if (!target) return;
      var selected = vopts(mainRow).filter(function (o) { return vqty(o) > 0; });
      if (selected.length === 1 && selected[0] !== target) {
        setVqty(target, vqty(selected[0]));
        setVqty(selected[0], 0);
      } else if (selected.length === 0) {
        setVqty(target, 1);
      }
      renderMix(mainRow);
      renderTiers();
    });

    // Klick i pickern: variant-stepper, rad-stepper eller rad-toggle
    root.addEventListener('click', function (e) {
      var vstep = e.target.closest('[data-gp-vstep]');
      if (vstep) {
        var opt = vstep.closest('[data-gp-vopt]');
        var container = opt.closest('[data-gp-row], [data-gp-main]');
        var isMain = container.hasAttribute('data-gp-main');
        var delta = parseInt(vstep.getAttribute('data-gp-vstep'), 10);
        var qty = Math.max(0, vqty(opt) + delta);
        // Huvudprodukten: minst 1 enhet totalt kvar
        if (isMain && qty === 0 && containerUnits(container) === vqty(opt)) qty = 1;
        setVqty(opt, qty);
        if (isMain) {
          if (qty > 0) {
            root.setAttribute('data-main-variant', opt.getAttribute('data-variant-id'));
            if (delta > 0) syncPageVariant(opt);
          }
        } else if (containerUnits(container) === 0) {
          container.classList.remove('is-checked');
          container.setAttribute('aria-checked', 'false');
        }
        renderMix(container);
        renderTiers();
        return;
      }
      var step = e.target.closest('[data-gp-step]');
      if (step) {
        var row = step.closest('[data-gp-row], [data-gp-main]');
        var isMainRow = row.hasAttribute('data-gp-main');
        var min = isMainRow ? 1 : 0;
        var q = Math.max(min, rowQty(row) + parseInt(step.getAttribute('data-gp-step'), 10));
        if (q === 0) {
          row.classList.remove('is-checked');
          row.setAttribute('aria-checked', 'false');
          setRowQty(row, 1);
        } else {
          setRowQty(row, q);
        }
        renderTiers();
        return;
      }
      if (e.target.closest('[data-gp-variants]')) return;
      var row = e.target.closest('[data-gp-row]');
      if (row) {
        // Eriks feedback 2026-08-10: klick var som helst på raden VÄLJER produkten,
        // men avmarkering sker ENDAST via klick på bocken (eller stepper ner till 0).
        if (row.classList.contains('is-checked') && !e.target.closest('.svd-gp__check')) return;
        toggleRow(row);
      }
    });

    // Tangentbord på raderna (role="checkbox") — steppers är riktiga
    // <button> och sköter sig själva.
    root.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var row = e.target.closest('[data-gp-row]');
      if (!row || e.target.closest('[data-gp-step]') || e.target.closest('[data-gp-vstep]')) return;
      e.preventDefault();
      toggleRow(row);
    });

    function toggleRow(row) {
      var checked = row.classList.toggle('is-checked');
      row.setAttribute('aria-checked', checked ? 'true' : 'false');
      if (isMulti(row)) {
        var opts = vopts(row);
        if (checked && containerUnits(row) === 0 && opts.length) setVqty(opts[0], 1);
        if (!checked) opts.forEach(function (o) { setVqty(o, 0); });
        renderMix(row);
      } else if (checked) {
        setRowQty(row, 1);
      }
      renderTiers();
    }

    // Visa fler / färre (texterna kommer från blockets inställningar)
    if (moreBtn && moreRows) {
      var labelMore = moreBtn.getAttribute('data-label-more') || 'Visa fler godisar';
      var labelLess = moreBtn.getAttribute('data-label-less') || 'Visa färre';
      moreBtn.addEventListener('click', function () {
        var open = moreRows.classList.toggle('is-open');
        moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        moreBtn.textContent = open ? '− ' + labelLess : '+ ' + labelMore + ' (' + moreCount + ')';
      });
    }

    // ============== Submit-intercept ==============
    // Interceptar köp av HUVUDPRODUKTEN (vilket formulär som helst vars
    // variant-id tillhör produkten — vanliga knappen och sticky-knappen).
    // Andra produkters formulär (quick add, rekommendationer) rörs aldrig.
    function formVariantId(form) {
      var idInput = form.querySelector('[name="id"]');
      return idInput ? String(idInput.value).trim() : '';
    }
    function isMainProductForm(form) {
      if (!form || form.getAttribute('action') === null) return false;
      if (form.getAttribute('action').indexOf('/cart/add') === -1) return false;
      return ownVariantIds.indexOf(formVariantId(form)) !== -1;
    }

    var processing = false;

    // Aktuellt variant-id för huvudprodukten (enkelvariant-läget & fallback):
    // pickerns eget läge först, annars produktformuläret.
    function resolveMainVariantId() {
      var own = parseInt(root.getAttribute('data-main-variant'), 10);
      if (!isNaN(own)) return own;
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var value = formVariantId(forms[i]);
        if (ownVariantIds.indexOf(value) !== -1) return parseInt(value, 10);
      }
      return NaN;
    }

    function packageItems(mainVariantId) {
      // _godispaket sätts bara när det faktiskt är ett paket (>1 enhet) —
      // ett ensamt köp via blockets knapp beter sig exakt som native.
      var isPackage = !gpPlain && totalBags() > 1;
      var properties = null;
      if (isPackage) {
        properties = {};
        properties[PROPERTY_KEY] = gpStamp || '1';
      }
      function item(id, qty) {
        return properties ? { id: id, quantity: qty, properties: properties } : { id: id, quantity: qty };
      }
      // En rad → ett line item per vald variant (multi) eller radens variant (enkel)
      function pushContainer(items, container, fallbackId) {
        if (isMulti(container)) {
          vopts(container).forEach(function (o) {
            var q = vqty(o);
            if (q < 1) return;
            var id = parseInt(o.getAttribute('data-variant-id'), 10);
            if (!isNaN(id)) items.push(item(id, q));
          });
        } else {
          var id = typeof fallbackId === 'number' ? fallbackId : parseInt(container.getAttribute('data-variant-id'), 10);
          if (!isNaN(id)) items.push(item(id, rowQty(container)));
        }
      }
      var items = [];
      if (mainIsMulti) {
        pushContainer(items, mainRow);
      } else {
        if (isNaN(mainVariantId)) return null;
        pushContainer(items, mainRow, mainVariantId);
      }
      checkedRows().forEach(function (row) { pushContainer(items, row); });
      return items.length ? items : null;
    }

    function resetPicker() {
      checkedRows().forEach(function (row) {
        row.classList.remove('is-checked');
        row.setAttribute('aria-checked', 'false');
        if (isMulti(row)) {
          vopts(row).forEach(function (o) { setVqty(o, 0); });
          renderMix(row);
        } else {
          setRowQty(row, 1);
        }
      });
      if (mainIsMulti) {
        var keepId = root.getAttribute('data-main-variant');
        var opts = vopts(mainRow);
        opts.forEach(function (o) { setVqty(o, 0); });
        var keep = mainRow.querySelector('[data-gp-vopt][data-variant-id="' + keepId + '"]') || opts[0];
        if (keep) setVqty(keep, mainDefaultQty);
        renderMix(mainRow);
      } else {
        setRowQty(mainRow, mainDefaultQty);
      }
      renderTiers();
    }

    function addPackage(mainVariantId, triggerBtn) {
      if (processing) return;
      processing = true;
      if (triggerBtn) triggerBtn.classList.add('is-loading');
      var items = packageItems(mainVariantId);
      if (!items) {
        processing = false;
        if (triggerBtn) triggerBtn.classList.remove('is-loading');
        return;
      }
      var wantedSections = hasUpCart() ? 'cart-bubble' : 'cart-drawer,cart-bubble';

      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: wantedSections,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e && e.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function (response) {
          try { root.dispatchEvent(new CustomEvent('svd:picker:added', { bubbles: true })); } catch (e) { /* svd-kontrakt */ }
          // Nollställ valen — paketet ligger i vagnen nu
          resetPicker();
          if (hasUpCart()) {
            renderDrawerSections(response);
            tryOpenUpCart();
          } else {
            openThemeCartDrawer(response);
          }
        })
        .catch(function (err) { console.warn('[svd-godispaket-v3] add-to-cart misslyckades', err); })
        .finally(function () {
          processing = false;
          if (triggerBtn) triggerBtn.classList.remove('is-loading');
        });
    }

    // Blockets egen köpknapp — lägger huvudprodukten (+ ev. valda tillägg).
    var atcBtn = root.querySelector('[data-gp-atc]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        addPackage(resolveMainVariantId(), atcBtn);
      });
    }

    function shouldIntercept() {
      return totalBags() > 1;
    }

    // Capture-fas på document — hinner före temats product-form-element.
    document.addEventListener('click', function (e) {
      if (!shouldIntercept()) return;
      var button = e.target.closest('.single-add-to-cart-button, button[name="add"]');
      if (!button) return;
      var form = button.closest('form') || button.form;
      if (!isMainProductForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addPackage(parseInt(formVariantId(form), 10));
    }, true);

    // Fallback om temat submittar formuläret på annan väg än knapp-klick.
    document.addEventListener('submit', function (e) {
      if (!shouldIntercept()) return;
      if (!isMainProductForm(e.target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addPackage(parseInt(formVariantId(e.target), 10));
    }, true);

    renderTiers();
  }

  function mountAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-svd-godispaket-v3]')).forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:block:select', mountAll);
  /* svd-kontrakt (Claude 2026-09-25): montera väljare som injicerats i produktkortets
     "Lägg till"-blad (assets/svd-popup-quickadd.js) — bara rötter i e.detail.root. */
  document.addEventListener('svd:picker:mount', function (e) {
    var host = e && e.detail && e.detail.root;
    if (!host || !host.querySelectorAll) return;
    Array.prototype.forEach.call(host.querySelectorAll('[data-svd-godispaket-v3]'), initPicker);
  });
})();
